import Divider from "@galaxy-io/dls/layout/Divider";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";
import type { ReactNode } from "react";
import { BaseHeader } from "@/components/workspace/base-header";

const Inset = styled.div`
  min-height: 72px;
  display: flex;
  align-items: center;
  padding: ${t.space[24]} var(--gtm-page-inset, ${t.space[24]}) ${t.space[16]};
  flex-shrink: 0;
  min-width: 0;
  width: 100%;
`;
export function PageHeader({
  title,
  leading,
  description,
  actions,
  divider = true,
}: {
  title: string;
  leading?: ReactNode;
  description?: string;
  actions?: ReactNode;
  divider?: boolean;
}) {
  return (
    <>
      <Inset>
        <BaseHeader leading={leading} title={title} description={description} actions={actions} />
      </Inset>
      {divider && <Divider />}
    </>
  );
}
